import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import classnames from 'classnames'
import styles from './index.module.less'

export default ({
  maxLength,
  outerIndex,
  onOuterChange,
}) => {
  return <>
    { outerIndex > 0 && <OuterArrow type="prev" step={-1} maxLength={maxLength} outerIndex={outerIndex} onOuterChange={onOuterChange} />}
    { outerIndex + 1 < maxLength && <OuterArrow type="next" step={1} maxLength={maxLength} outerIndex={outerIndex} onOuterChange={onOuterChange} />}
  </>
}

const OuterArrow = ({ maxLength, outerIndex, type, step, onOuterChange }) => {
  return (
    <div className={classnames(styles['outer-arrow-wrap-wrap'])}>
      <div className={classnames('outer-arrow-wrap', 'fill-grey-bg', type)}>
        <Icon
          onClick={() => { (outerIndex + step < maxLength && outerIndex + step >= 0) && onOuterChange(outerIndex + step, step) }}
          className="outer-arrow"
          type={type === 'next' ? 'm-Vxing_you' : 'm-Vxing_zuo'}
        />
      </div>
    </div>
  )
}
